<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
<!--    <div class="fs-2" mat-dialog-title>-->
<!--        Inscription-->
<!--        <i class="fa fa-close" (click)="onNoClick()" *ngIf="disableClose == false" aria-hidden="true"></i>-->
<!--    </div>-->
    <div mat-dialog-content>
        <img src="assets/logo-inline.png" class="logo"/>

        <h1 class="free-trial">
            Essayez gratuitement
        </h1>

        <app-alert></app-alert>

        <div class="row">
            <div class="btns_social">
                <a class="btn btn-facebook" (click)="signInWithFB()">
                    <img src="/assets/logo-facebook.avif"/>
                </a>
                <a class="btn btn-google" (click)="signInWithGoogle()">
                    <img src="/assets/Google_icon-icons.com_66793.png"/>
                </a>
            </div>

            <hr class="ou">
            <div class="col-6">
                <div class="form-group">
                    <mat-form-field>
                        <mat-label>Prénom</mat-label>
                        <input matInput formControlName="firstName" placeholder="Prénom" class="text">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <mat-form-field>
                        <mat-label>Nom</mat-label>
                        <input matInput formControlName="lastName" placeholder="Nom" class="text">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="form-group">
            <mat-form-field>
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="username" placeholder="E-mail" class="text">
            </mat-form-field>
        </div>
        <div class="form-group">
            <mat-form-field>
                <mat-label>Mot de passe</mat-label>
                <input matInput formControlName="text_password" [type]="hide ? 'password' : 'text'"
                       class="text">
                <p mat-icon-button matSuffix class="mb-0" (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                   [attr.aria-pressed]="hide">
                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </p>
                <!--                            <mat-hint><a href="#">Mot de passe oublié</a></mat-hint>-->
                <mat-error
                    *ngIf="registerForm.get('text_password').invalid">{{formService.getErrorMessage(registerForm.get('text_password'))}}</mat-error>
            </mat-form-field>
        </div>

    </div>
    <div mat-dialog-actions class="register">

        <button type="submit" class="btn btn-primary btn-lg w-100 mb-3">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            Valider l'inscription
        </button>
        <p>
            Déjà inscrit ? <a class="cursor-pointer" (click)="login()">Se connecter</a>
        </p>
        <div>
            <small>
                En m'inscrivant, je déclare avoir pris connaissance des
                <a href="https://www.lybox.fr/cgu" target="_blank">conditions générales d’utilisation</a>
                du site internet et les accepter.
            </small>
        </div>
    </div>
</form>
